import { useSelector } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import HybridField from '../../../../components/HybridField/HybridField';
import formatPhoneNumber from '../../../../utils/functions/formatPhoneNumber';
import PropTypes from 'prop-types';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import PhoneField from '../../../../components/PhoneField/PhoneField';
import dayjs from 'dayjs';

export default function AboutCollum({ control, isEditing, errors }) {
  const { usersData } = useSelector((state) => state.user);
  const { perfisData } = useSelector((state) => state.perfis);
  const initialProfile = perfisData?.filter(
    (initialProfile) => initialProfile.NOME === usersData.NOMECOBAN
  );

  return (
    <>
      <Styled.InformationContainer>
        <h3>SOBRE</h3>
        <HybridField
          control={control}
          title={'Nome/Razão Social'}
          disabled={!isEditing}
          width={'29.306vw'}
          name={'NOME'}
          error={errors.NOME && true}
          value={usersData.NOME}
          margin={'1.389vw 0 0 0'}
        />
        <Styled.Row>
          <HybridField
            control={control}
            title={'Nascimento/Fundação'}
            disabled={!isEditing}
            width={'13.958vw'}
            type={'date'}
            name={'NASCIMENTO'}
            error={errors.NASCIMENTO && true}
            margin={'1.389vw 0 0 0'}
          />
          <PhoneField
            control={control}
            title={'Telefone'}
            value={usersData.TELEFONE}
            disabled={!isEditing}
            width={'13.958vw'}
            name={'TELEFONE'}
            error={errors.TELEFONE && true}
            margin={'1.389vw 0 0 1.389vw'}
          />
        </Styled.Row>
        <HybridField
          control={control}
          title={'E-mail'}
          value={usersData.EMAIL}
          disabled={!isEditing}
          width={'29.306vw'}
          type={'email'}
          name={'EMAIL'}
          error={errors.EMAIL && true}
          margin={'1.389vw 0 0 0'}
        />
        {initialProfile[0] && (
          <Styled.ContainerCobanProfile>
            <h4>Perfil</h4>
            <SelectOptions
              width={'29.306vw'}
              control={control}
              options={perfisData}
              initialValue={initialProfile[0]?.ID}
              initialName={initialProfile[0]?.NOME}
              padding={'1vw'}
              disabled={!isEditing}
              name={'perfil'}
            />
          </Styled.ContainerCobanProfile>
        )}
      </Styled.InformationContainer>
    </>
  );
}

AboutCollum.propTypes = {
  control: PropTypes.any,
  isEditing: PropTypes.bool,
  errors: PropTypes.object,
};
